export default __webpack_public_path__ + "static/apercu-regular-cf68b215b76b81515ea6bde0b5fb2309.woff2";